module.exports = __webpack_public_path__ + "img/about.1cca4fa7.jpg";